import React, { useContext, useEffect, useState } from 'react';
import _ from 'lodash';

import JobListContext from '../../context/jobListContext';
import AppStateContext from '../../context/appStateContext';
import AssetListContext from '../../context/assetListContext'

import PlannedStatusBubble from '../../../components/plannedStatusBubble';
import LocationLabel from '../../../components/locationLabel';
import DateLabel from '../../../components/dateLabel';
import ExportButton from "../../../components/exportButton";
import GetAssetsListFunction from '../../../functions/GetAssetsListFunction';
import GetAssetAttributes from "../../../functions/GetAssetAttributes";
import JobDetailAssetCardList from '../Lists/jobDetailAssetCardList';
import MaintenanceTypeBubble from '../../../components/maintenanceTypeBubble';
import useTextCorrection from '../../../hooks/useTextCorrection';
import DetailsTable from "../../../components/detailsTable";
import APIHelper from "../../../hooks/useAPIHelper";
import {tableData} from "../../../hooks/useFilterHelper";
import ApiStatus,{POPULATED,CALLING,EMPTY} from "../../../components/apiStatus";

import {
  BubbleTitle,
  BubbleSection,
  ContentCtn,
  HeadingDescCtn,
  HeadingDesc,
  JobDetailCtn,
  JobTitle,
  SectionTitle,
  RoutineDescriptionCtn,
  AssetDetailList,
  ButtonCtn,
} from './index.style';

const JobDetailPlanned: React.FC<any> = (): React.ReactElement => {
  const { selectedPlannedJob, clearSelectedPlannedJob, setAppJobDetails, updatePlannedAttributes } = useContext(JobListContext);
  const { token } = useContext(AppStateContext);
  const { clearAssetDetails } = useContext(AssetListContext);

  const [renderedAsset, setRenderedAsset] = useState([]);
  const [currentApiStatus, setCurrentApiStatus] = useState(CALLING);

  const getAsset = APIHelper();
  const tableHeadings = tableData['planned'];

  const assetCallback = (data: []| string) => {
    if (data == 'timeout') {
      setCurrentApiStatus(EMPTY);
      return;
    }

    setCurrentApiStatus(POPULATED);
    if (typeof data == 'object') {
      updateMake(data.Make);
      setRenderedAsset([data]);
    } else {
      updateMake(data[0].Make);
      setRenderedAsset(data);
    }
  };

  const updateMake = (makeName: string) => {
    let oldPlannedJob = _.cloneDeep(selectedPlannedJob);

    setAppJobDetails({
      selectedPlannedJob: _.assign(oldPlannedJob,{
        Make: makeName
      })
    })
  };

  useEffect(() => {
    return () => {
      clearAssetDetails();
      clearSelectedPlannedJob();
    }
  },[]);

  useEffect(() => {

    if(selectedPlannedJob.PMCallNo == '' || selectedPlannedJob.PMCallNo == 0) {
      setCurrentApiStatus(EMPTY);
      return;
    }

    if(selectedPlannedJob.SerialNo != "") {
      setCurrentApiStatus(CALLING);
      let filter: string = `<Filters><SerialNo><Like>${selectedPlannedJob.SerialNo}</Like></SerialNo></Filters>`;
      getAsset.run(GetAssetsListFunction,assetCallback,[filter, token, selectedPlannedJob.ContractNo]).then(() => {
        getAsset.run(GetAssetAttributes, (data: []) => updatePlannedAttributes(data), [token, selectedPlannedJob.SerialNo]);
      });
    }
  },[selectedPlannedJob.PMCallNo]);

  const { filterText, replaceBreaks } = useTextCorrection();

  return (
    <JobDetailCtn>
      <ContentCtn>
        <JobTitle>{filterText(selectedPlannedJob.ItemDescription)}</JobTitle>
        <HeadingDescCtn>
          <HeadingDesc>
            <LocationLabel location={selectedPlannedJob.UnitLocation} />
          </HeadingDesc>
          <HeadingDesc>
            <DateLabel
              slaStatus={selectedPlannedJob.StatusCode == 'F' ? 'doneOnTime' : 'upcoming'}
              date={selectedPlannedJob.RoutineDueDate}
              page="planned"
            />
          </HeadingDesc>
        </HeadingDescCtn>
        <BubbleSection>
          <div>
            <BubbleTitle>Status</BubbleTitle>
            <PlannedStatusBubble status={selectedPlannedJob.Status} />
          </div>
          <div>
            <BubbleTitle>Maintenance type</BubbleTitle>
            <MaintenanceTypeBubble type={selectedPlannedJob.RoutineCode} />
          </div>
        </BubbleSection>
        <RoutineDescriptionCtn>
          <SectionTitle>Routine procedure tasks</SectionTitle>
          <div>{replaceBreaks(selectedPlannedJob.RoutineProcedureTaskText)}</div>
        </RoutineDescriptionCtn>
        <AssetDetailList>
          <SectionTitle>Asset</SectionTitle>
          <ApiStatus status={currentApiStatus} type="bar" >
            <JobDetailAssetCardList assetList={renderedAsset} location="planned" />
          </ApiStatus>
        </AssetDetailList>
        <div>
          <SectionTitle>Maintenance details</SectionTitle>
          <DetailsTable headings={tableHeadings} tableData={selectedPlannedJob}/>
        </div>
      </ContentCtn>
      <ButtonCtn>
        <ExportButton data={selectedPlannedJob} columns={Object.values(tableHeadings)}/>
      </ButtonCtn>
    </JobDetailCtn>
  );
};

export default JobDetailPlanned;
